import * as dashboardSelectors from '@/dashboard/dashboard-selectors';
import { useSelector } from 'react-redux';
import { AsyncUniversalSearchDrawer } from './async-universal-search-drawer';

export const UniversalSearchWrapper = () => {
  const isUniversalSearchActive = useSelector(
    dashboardSelectors.isUniversalSearchActive
  );

  if (!isUniversalSearchActive) return null;

  return <AsyncUniversalSearchDrawer />;
};
